import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const zonarConfig: TSPConfig = {
  key: 'zonar',
  name: 'Zonar',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>
        To connect your Zonar account, retrieve your API credentials from the
        Ground Traffic Control (GTC) dashboard:
      </p>
      <ol>
        <li>
          Log into Zonar and go to{' '}
          <strong>Manage &gt; System Settings &gt; Users</strong>.
        </li>
        <li>
          Find the <strong>OMI API user</strong> you'll use for integration.
          <ul>
            <li>
              Use the <strong>API username</strong> (not the email address)
            </li>
            <li>
              Ensure the user has the <strong>OMI role</strong> and required
              permissions
            </li>
          </ul>
        </li>
        <li>
          Enter the following credentials below:
          <ul>
            <li>API Username (case-sensitive)</li>
            <li>Password</li>
            <li>Zonar GTC Account Number</li>
          </ul>
        </li>
      </ol>
      <p>If you need help, contact your Zonar administrator or support.</p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API Username (with OMI role)',
          name: 'username',
          type: 'text',
          required: true,
        },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'Customer GTC Code',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default zonarConfig;
